export const ConversationIcon = () => (
  <svg width='41' height='40' viewBox='0 0 41 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clip-path='url(#clip0)'>
      <path
        d='M7.25771 19.6523H7.01195L6.82372 19.8103L1.175 24.5521V4.13636C1.175 2.24362 2.72516 0.675 4.50881 0.675H22.4912C24.2748 0.675 25.825 2.24362 25.825 4.13636V16.1909C25.825 18.0837 24.2748 19.6523 22.4912 19.6523H7.25771Z'
        fill='white'
        stroke='#3B3B3E'
        stroke-width='1.35'
      />
      <path
        d='M33.9305 33.9159L33.7465 33.7705H33.512H17.6692C15.7737 33.7705 14.175 32.1767 14.175 30.3091V18.1364C14.175 16.2687 15.7737 14.675 17.6692 14.675H36.3708C38.2663 14.675 39.865 16.2687 39.865 18.1364V38.6062L33.9305 33.9159Z'
        fill='white'
        stroke='#3B3B3E'
        stroke-width='1.35'
      />
      <path
        d='M5.5 8H21.5'
        stroke='#3B3B3E'
        stroke-width='1.35'
        stroke-miterlimit='10'
        stroke-linecap='round'
      />
      <path
        d='M7.5 11.5151H19.5'
        stroke='#3B3B3E'
        stroke-width='1.35'
        stroke-miterlimit='10'
        stroke-linecap='round'
      />
      <path
        d='M27.5 30C30.8137 30 33.5 27.3137 33.5 24C33.5 20.6863 30.8137 18 27.5 18C24.1863 18 21.5 20.6863 21.5 24C21.5 27.3137 24.1863 30 27.5 30Z'
        fill='#DBA900'
      />
      <path
        d='M32.5 20L26.9127 26L24.5 23.4667'
        stroke='white'
        stroke-width='1.35'
        stroke-miterlimit='10'
        stroke-linecap='round'
      />
    </g>
    <defs>
      <clipPath id='clip0'>
        <rect width='40' height='40' fill='white' transform='translate(0.5)' />
      </clipPath>
    </defs>
  </svg>
)
